$(() => {
    let padding = 20;
    $('.page-push').css('--height', ($('#masthead').height()+padding) + 'px');

      $('.toggle-mobile-menu').on('click', e => {
          e.preventDefault();

          $('#masthead').toggleClass('menu-open');
          $('body').toggleClass('menu-open');
      });

      $('.back-to-top').on('click', e => {
            e.preventDefault();

            $('html, body').animate({
                scrollTop: 0
            }, 500);
      });

    let wrapper = $('.placeholder-img__wrapper');
    wrapper.css('--from-height', '100px');

    // On page load, animate the height of the homepage hero video to the iframe's aspect ratio

    let heroVideoIframeHeight = resizeHomepageHero(false).then(height => {
        wrapper.css('--to-height', height + 'px');
        wrapper.addClass('animate');
    });

    // Change this on resize
    $(window).on('resize', () => {
        heroVideoIframeHeight = resizeHomepageHero(true);
        $('.page-push').css('--height', ($('#masthead').height()+padding) + 'px');
    });

    // Convert the below function a Promise
    function resizeHomepageHero(setHeight = true) {
        return new Promise((resolve, reject) => {
            // Set height of homepage hero video to the iframe's aspect ratio
            const $heroVideo = $('.placeholder-img__wrapper');
            const $heroVideoIframe = $heroVideo.find('iframe');
            const heroVideoIframeHeight = $heroVideoIframe.height();
            const heroVideoIframeWidth = $heroVideoIframe.width();
            const heroVideoIframeAspectRatio = heroVideoIframeHeight / heroVideoIframeWidth;
            const heroVideoHeight = $heroVideo.width() * heroVideoIframeAspectRatio;

            // Find the nearest .contain and set its height to the hero video's height
            const $heroVideoContainer = $('.video-wrapper>.contain');

            if(setHeight) {
                $heroVideo.height(heroVideoHeight);
                $heroVideo.css('max-height', heroVideoHeight);
                $heroVideo.css('min-height', heroVideoHeight);

                $heroVideoContainer.height(heroVideoHeight);
                $heroVideoContainer.css('max-height', heroVideoHeight);
                $heroVideoContainer.css('min-height', heroVideoHeight);
            }

            resolve(heroVideoIframeHeight);
        });
    }

    $('a[href*="#"]:not([href="#"])').on('click', function(e) {
        e.preventDefault();
        const $target = $(this.hash);
        const $masthead = $('#masthead');
        const $targetOffset = $target.offset().top;

        let height = $masthead.height();

        // if we are on mobile, don't use the masthead height
        if($(window).width() < 768) {
            height = 0;
        }

        const $scrollPosition = $targetOffset - height;

        $('html, body').animate({
            scrollTop: $scrollPosition
        }, 500);
    });
});

// on scroll down add a class to the masthead
$(window).on('scroll', () => {
    const $masthead = $('#masthead');
    const $scrollPosition = $(window).scrollTop();

    if($scrollPosition > 0) {
        $masthead.addClass('scrolled');
    } else {
        $masthead.removeClass('scrolled');
    }
});

// add a class to the masthead when the cursor is near the top of the page
// $(document).on('mousemove', e => {
//     const $masthead = $('#masthead');
//     const $mastheadHeight = $masthead.height();
//     const $mouseY = e.clientY;
//
//     if($mouseY < $mastheadHeight) {
//         $masthead.addClass('near-top');
//     } else {
//         $masthead.removeClass('near-top');
//     }
// });

// Make navigation appear on scroll up
let lastScrollTop = 0;
$(window).on('scroll', () => {
    const $masthead = $('#masthead');
    const $scrollPosition = $(window).scrollTop();

    if($scrollPosition > lastScrollTop) {
        $masthead.removeClass('near-top');
    } else {
        $masthead.addClass('near-top');
    }

    lastScrollTop = $scrollPosition;
});